import { DeleteAnnouncementDialogState } from './delete-announcement-dialog.state';

/**
 * Initialer State für den Delete-Announcement-Dialog.
 */
export const deleteAnnouncementDialogStateInitial: DeleteAnnouncementDialogState = {
  isOpen: false,
  itemToDelete: undefined,
};
